import { ArrowForwardIos } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BodyAskDeleteModal from './bodyAskDeleteModal';
const BodyCategory = ({
  type,
  setTypeAsk,
  categories,
  setOpenAsk,
  setSelectedCategory,
  arrowFunction,
  setTableNameBox,
  typeCategory,
  setOpenCreateSession,
  dataFunction,
  setSelectedProgram,
  setSessions,
}) => {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const [openAskDelete, setOpenAskDelete] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          <Button
            sx={{
              width: '48px',
              height: '28px',
              border: 'red 1px solid',
              color: 'red',
              mr: '5px',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: 600,
              textAlign: 'center',
            }}
            onClick={() => {
              setOpenAskDelete(true);
            }}>
            {t('Delete')}
          </Button>
          <Button
            sx={{
              width: '48px',
              height: '28px',
              mr: '5px',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: 600,
              textAlign: 'center',
            }}
            onClick={() => {
              if (typeCategory === 'sessions') {
                setSelectedCategory(categories.id);
                setOpenCreateSession(true);
              } else {
                setSelectedCategory(categories);
                setOpenAsk(true);
              }
              setTableNameBox(type);
              setTypeAsk('edit');
            }}
            variant="contained">
            {t('EDIT')}
          </Button>

          <Typography
            sx={{
              marginLeft: '5px',
              width: '100px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
            {categories.name}
          </Typography>
        </Box>
        {(typeCategory === 'programs' || typeCategory === 'categories') && (
          <Box
            sx={{
              mr: '10px',
              ':hover': {
                cursor: 'pointer',
              },
            }}
            onClick={() => {
              setSelectedCategory(categories);
              if (typeCategory === 'categories') {
                setSelectedProgram({ catId: categories.id });
              }
              typeCategory === 'categories' && setSessions([]);
              arrowFunction(categories.id);
            }}>
            <ArrowForwardIos />
          </Box>
        )}
      </Box>
      <hr></hr>
      {openAskDelete === true && (
        <BodyAskDeleteModal
          setOpenAskDelete={setOpenAskDelete}
          openAskDelete={openAskDelete}
          mode={type}
          data={categories}
          dataFunction={dataFunction}
        />
      )}
    </Box>
  );
};

export default BodyCategory;
